import type { ProductAdderStep } from '../features/productAdder/types/productAdder';

export function shouldHideSteps(currentStep: ProductAdderStep | undefined, isNewSeatMapEnabled: boolean): boolean {
  if (!isNewSeatMapEnabled) return false;
  return currentStep === 'seat_map';
}
